import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { PptxExportPayload } from './payload-builder';

/**
 * Posts the canonical export payload to the backend exporter and receives the
 * generated `.pptx` as a binary blob (nothing is persisted server-side).
 */
@Injectable({
  providedIn: 'root'
})
export class PptxExportService {
  private readonly http = inject(HttpClient);

  exportPptx(payload: PptxExportPayload): Observable<Blob> {
    const url = environment.apiURL + '/results/pptx';
    return this.http.post(url, payload, { responseType: 'blob' });
  }
}
